import React from 'react';
import Dashboard from './generic-dashboard';
export { isNewConstructionTooSoon } from '../../cards/close-date';

const DistantNewConstructionDashboard = ({ firstName, props, children = null }) => (
  <Dashboard
    message={`Hey ${firstName}, thanks for submitting your information. We'll be in touch about your next steps.`}
    articles={[
      {
        href: '7-reasons-only-1-in-4-homebuyers-shop-for-a-mortgage',
        title: '7 Reasons Only 1 in 4 Homebuyers Shop for a Mortgage'
      },
      {
        href: 'decoding-mortgage-jargon',
        title: 'Decoding Mortgage Jargon'
      },
      {
        href: 'the-5-dangers-of-mortgage-calculators',
        title: 'The 5 Dangers of Mortgage Calculators'
      }
    ]}
    props={props}
  >
    {children}
  </Dashboard>
);

export default DistantNewConstructionDashboard;



// WEBPACK FOOTER //
// ./src/products/shared/distant-new-construction-dashboard.js